const allSections = document.querySelectorAll('body section.quiz-step, body section.quiz-result-detail, body section.quiz-result-products, body section.quiz-common');

const sectionsNotInMain = Array.from(allSections).filter(
  section => section.closest('main')
);

function hideAllSections() {

  let sections = document.querySelectorAll('main .shopify-section');

  sections.forEach((section, index) => {
    // Skip first and second sections (index 0 and 1)
    if (index > 1 && section.closest('main') && !section.classList.contains('footer') && section.tagName.toLowerCase() !== 'footer') {
      section.style.display = 'none';
    }

  });
  let heroImageTextTextContainer = document.querySelector('.hero-image-text__text-container');
  if (heroImageTextTextContainer) {
    heroImageTextTextContainer.querySelectorAll('button[type="button"]').forEach(button => {
      button.addEventListener('click', () => {
        let currentSection = button.closest('section');
        let questionContainer = currentSection;
        
        // Check if we have required fields that need validation
        if (questionContainer && questionContainer.querySelectorAll('input[required]').length) {
          let requiredInput = questionContainer.querySelector('input[required]');
          // Check if it's a radio button and if any is checked
          if (requiredInput.type === 'radio') {
            let checkedRadio = questionContainer.querySelector('input[required]:checked');
            if (!checkedRadio) {
              // No radio button is checked, validate
              let isValid = validate(requiredInput, questionContainer);
              if (!isValid) return;
            } else {
              // Radio is checked, remove any error messages
              questionContainer.querySelectorAll('input[required]').forEach((e) => {
                e.classList.remove('error');
              });
              let errorMsg = questionContainer.querySelector('.error-message');
              if (errorMsg) errorMsg.remove();
            }
          } else {
            // Other input types (text, email, etc.)
            let isValid = validate(requiredInput, questionContainer);
            if (!isValid) return;
          }
        }
        
        button.closest('section').style.display = 'none';
        let closestPage = button.closest('.page');
        if (closestPage) {
          sectionsNotInMain.forEach((section, index) => {
            if (index === 0) {
              section.style.display = 'block';
              
              // Update URL hash to reflect the current step
              // Try to find the step number from section classes or data attributes
              let stepNumber = null;
              
              // First, check if button has a link inside with href
              let buttonLink = button.querySelector('a[href^="#quiz-step"]');
              if (buttonLink) {
                let href = buttonLink.getAttribute('href');
                let hrefMatch = href.match(/#quiz-step(\d+)/i);
                if (hrefMatch) {
                  stepNumber = hrefMatch[1];
                }
              }
              
              // If not found, try to find from section
              if (!stepNumber && section.classList.contains('quiz-step')) {
                // Extract step number from section ID or class
                let stepMatch = section.id ? section.id.match(/quiz-step-?(\d+)/i) : null;
                if (stepMatch) {
                  stepNumber = stepMatch[1];
                } else {
                  // Try to find step number from any link in the section
                  let stepLink = section.querySelector('a[href^="#quiz-step"]');
                  if (stepLink) {
                    let href = stepLink.getAttribute('href');
                    
                    let hrefMatch = href.match(/#quiz-step(\d+)/i);
                    if (hrefMatch) {
                      stepNumber = hrefMatch[1];
                      let stepLinkText = stepLink.textContent?.trim();
                      if (stepLinkText && stepNumber > 1 && stepLinkText?.toLocaleLowerCase()?.includes("next")) {
                        stepNumber = stepNumber - 1;
                      }
                    }
                  }
                }
              }
              
              // If we found a step number, update the URL hash and progress bar
              if (stepNumber) {
                window.location.hash = '#quiz-step' + stepNumber;
                updateProgressBar(parseInt(stepNumber, 10));
              } else if (index === 0 && sectionsNotInMain.length > 0) {
                // Default to quiz-step2 if it's the first section
                window.location.hash = '#quiz-step2'; 
                updateProgressBar(2);
              }
            }
          });
        }
      });
    });
  }
}

var hasError = (field) => {
  // Don't validate submits, buttons, file and reset inputs, and disabled fields
  if (field.type === 'submit' || field.type === 'button') return;

  // Get validity
  let validity = field.validity;

  // If valid, return null
  if (validity.valid) return;

  // If field is required and empty
  if (validity.valueMissing) return true;

  // If not the right type
  if (validity.typeMismatch) {
    // Email
    if (field.type === 'email') return true;
  }
  return false;
};

var validate = (element, container) => {
  // Validate the field
  var error = hasError(element);

  // If there's an error, show it
  if (error && container.querySelector('.error-message') == null) {
    let error_p = document.createElement("p");
    error_p.append("This question is required.");
    error_p.classList.add('error-message');
    if (container.querySelector('.rich-text__heading')) {
      container.querySelector('.rich-text__heading').after(error_p);
    } else {
      container.prepend(error_p);
    }

    container.querySelectorAll('input[required]').forEach((e) => {
      e.classList.add('error');
    });
    return false;
  } else if (error && container.querySelector('.error-message')) { 
    // error exist on page
    return false;
  } else if (container.querySelector('.error-message')) {
    // Otherwise, remove any existing error message
    container.querySelectorAll('input[required]').forEach((e) => {
      e.classList.remove('error');
    });
    container.querySelector('.error-message').remove();
    return true;
  }

  return true;
}

// Cookie helper functions
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(c.substring(nameEQ.length, c.length));
      } catch (e) {
        return c.substring(nameEQ.length, c.length);
      }
    }
  }
  return null;
}

// Function to save quiz data to cookie
function saveQuizData() {
  let selectedRadioValues = [];
  document.querySelectorAll('.quiz-step input[type="radio"]:checked').forEach((radio) => {
    selectedRadioValues.push(radio.value?.toLowerCase().trim());
  });
  
  if (selectedRadioValues.length > 0) {
    setCookie('quiz_data', JSON.stringify(selectedRadioValues), 30); // Store for 30 days
  }
}

// Function to check quiz data cookie and show/hide button
function toggleRequestMyResultButton() {
  let quizData = getCookie('quiz_data');
  let requestButton = document.querySelector('a[href="#request-my-result"]');
  
  if (requestButton) {
    if (quizData && Array.isArray(quizData) && quizData.length > 0) {
      // Show button if quiz data exists
      requestButton.style.display = '';
      let buttonBlock = requestButton.closest('.button-block');
      let buttonBlockButton = requestButton.closest('.button-block__button');
      if (buttonBlock) buttonBlock.style.display = '';
      if (buttonBlockButton) buttonBlockButton.style.display = '';
      // Remove any hidden class
      requestButton.classList.remove('hidden');
      if (buttonBlock) buttonBlock.classList.remove('hidden');
      if (buttonBlockButton) buttonBlockButton.classList.remove('hidden');
    } else {
      // Hide button if no quiz data
      requestButton.style.display = 'none';
      let buttonBlock = requestButton.closest('.button-block');
      let buttonBlockButton = requestButton.closest('.button-block__button');
      if (buttonBlock) buttonBlock.style.display = 'none';
      if (buttonBlockButton) buttonBlockButton.style.display = 'none';
    }
  }
}

// Helper function to get current step number
function getCurrentStepNumber() {
  // First, try to get from URL hash
  let hashMatch = window.location.hash.match(/#quiz-step(\d+)/i);
  if (hashMatch) {
    return parseInt(hashMatch[1], 10);
  }
  
  // If not in hash, find the currently visible quiz step
  let quizStepsSections = document.querySelectorAll('.quiz-step');
  for (let i = 0; i < quizStepsSections.length; i++) {
    if (quizStepsSections[i].style.display !== 'none' && 
        window.getComputedStyle(quizStepsSections[i]).display !== 'none') {
      return i + 1;
    }
  }
  
  return null;
}

// Helper function to get total number of quiz steps
function getTotalQuizSteps() {
  return document.querySelectorAll('.quiz-step').length;
}

// Function to initialize progress bar (hide by default)
function initializeProgressBar() {
  // Try to find the progress bar section - check for .new-quiz first, then fallback to .main
  let progressSection = document.querySelector('.new-quiz .main .shopify-section:first-of-type') ||
                        document.querySelector('.main .shopify-section:first-of-type');
  
  if (progressSection) {
    // Hide progress bar by default
    if(window.currentStep >= 1) {
      progressSection.style.display = 'block';
    } else {
      progressSection.style.display = 'none';
    }
  }
}

// Function to update progress bar
function updateProgressBar(currentStep) {
  window.currentStep = currentStep;
  if (!currentStep || currentStep < 1) return;
  
  let totalSteps = getTotalQuizSteps();

  if (totalSteps === 0) return;
  
  // Calculate progress percentage
  let progressPercentage = (currentStep / totalSteps) * 100 + '%';
  
  // Try to find the progress bar section - check for .new-quiz first, then fallback to .main
  let progressSection = document.querySelector('.new-quiz .main .shopify-section:first-of-type') ||
                        document.querySelector('.main .shopify-section:first-of-type');
  
  if (progressSection) {
    progressSection.style.setProperty('--progress-width', progressPercentage);
    
    // Show progress bar if step >= 2, hide if step === 1
    // if (currentStep >= 2) {
    //   progressSection.style.display = 'block';
    // } else if (currentStep === 1) {
    //   progressSection.style.display = 'none';
    // }

    if (currentStep >= 1) {
      progressSection.style.display = 'block';
    }
  }
}

// Function to navigate to a specific step
function navigateToStep(stepNumber) {
  if (!stepNumber || stepNumber < 1) return;
  
  let quizStepsSections = document.querySelectorAll('.quiz-step');
  quizStepsSections.forEach((section, index) => {
    if (index + 1 == stepNumber) {
      section.style.display = 'block';
    } else {
      section.style.display = 'none';
    }
  });
  
  // Hide all quiz-result sections when navigating to a step
  document.querySelectorAll('.quiz-result').forEach((section) => {
    section.style.display = 'none';
  });
  
  // Update progress bar
  updateProgressBar(stepNumber);
  
  // Update URL hash
  window.location.hash = '#quiz-step' + stepNumber;
}

// Function to navigate to results (show all quiz-result sections and subsequent sections)
function navigateToResults() {
  window.currentStep = null;
  // Hide all quiz steps
  document.querySelectorAll('.quiz-step').forEach((section) => {
    section.style.display = 'none';
  });
  
  // Hide progress bar when showing results
  let progressSection = document.querySelector('.new-quiz .main .shopify-section:first-of-type') ||
                        document.querySelector('.main .shopify-section:first-of-type');
  if (progressSection) {
    progressSection.style.display = 'none';
  }
  
  // Find all sections
  let allSections = Array.from(document.querySelectorAll('main .shopify-section'));
  
  // Find the index of the first quiz-result section
  let firstResultIndex = -1;
  for (let i = 0; i < allSections.length; i++) {
    if (allSections[i].classList.contains('quiz-result')) {
      firstResultIndex = i;
      break;
    }
  }
  
  // Show all quiz-result sections and all sections after the first quiz-result
  allSections.forEach((section, index) => {
    if (section.classList.contains('quiz-result')) {
      // Show all quiz-result sections
      section.style.display = 'block';
    } else if (firstResultIndex >= 0 && index > firstResultIndex) {
      // Show all sections that come after the first quiz-result section
      section.style.display = 'block';
    } else {
      // Hide all other sections
      section.style.display = 'none';
    }
  });
  
  // Save quiz data to cookie
  saveQuizData();
  
  // Update URL hash
  window.location.hash = '#see-my-results';
}

// Function to add validation to quiz step navigation links
function addQuizStepValidation() {
  // Handle links with href starting with #quiz-step (forward and backward navigation)
  document.querySelectorAll('a[href^="#quiz-step"]').forEach(link => {
    // Skip if already has validation listener (check for data attribute)
    if (link.hasAttribute('data-quiz-validation')) return;
    link.setAttribute('data-quiz-validation', 'true');
    
    link.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      let target = evt.target.getAttribute('href') ? evt.target : evt.target.closest('a');
      if (!target) return;
      
      // Get the href to extract step number
      let href = target.getAttribute('href');
      let stepMatch = href ? href.match(/#quiz-step(\d+)/i) : null;
      let targetStepNumber = stepMatch ? parseInt(stepMatch[1], 10) : null;
      
      // Check if it's a back button (btn--secondary class)
      let isBackButton = target.classList.contains('btn--secondary');
      
      if (isBackButton) {
        // Handle backward navigation - no validation needed
        // If href specifies a step number, use it; otherwise go to previous step
        if (targetStepNumber) {
          navigateToStep(targetStepNumber);
        } else {
          // Calculate previous step from current step
          let currentStep = getCurrentStepNumber();
          if (currentStep && currentStep > 1) {
            let previousStep = currentStep - 1;
            navigateToStep(previousStep);
          }
        }
      } else if (target.classList.contains('btn--primary') || target.classList.contains('btn--callout')) {
        // Handle forward navigation with validation
        let questionContainer = target.closest('section');
        if (!questionContainer) {
          questionContainer = target.closest('.section-blocks') || target.closest('.shopify-section');
        }
        
        // Check if this is a link to see results
        let isSeeResultsLink = href && (href === '#see-my-results' || href.includes('#see-my-results'));
        
        // Check if we have required fields that need validation
        if (questionContainer && questionContainer.querySelectorAll('input[required]').length) {
          let requiredInput = questionContainer.querySelector('input[required]');
          // Check if it's a radio button and if any is checked
          if (requiredInput.type === 'radio') {
            let checkedRadio = questionContainer.querySelector('input[required]:checked');
            if (!checkedRadio) {
              // No radio button is checked, validate
              let isValid = validate(requiredInput, questionContainer);
              if (!isValid) {
                evt.preventDefault();
                evt.stopPropagation();
                return false;
              }
            } else {
              // Radio is checked, remove any error messages
              questionContainer.querySelectorAll('input[required]').forEach((e) => {
                e.classList.remove('error');
              });
              let errorMsg = questionContainer.querySelector('.error-message');
              if (errorMsg) errorMsg.remove();
            }
          } else {
            // Other input types (text, email, etc.)
            let isValid = validate(requiredInput, questionContainer);
            if (!isValid) {
              evt.preventDefault();
              evt.stopPropagation();
              return false;
            }
          }
        }
        
        // If validation passed, navigate to target
        if (isSeeResultsLink) {
          // Collect all selected radio button values from all quiz steps
          let selectedRadioValues = [];
          document.querySelectorAll('.quiz-step input[type="radio"]:checked').forEach((radio) => {
            selectedRadioValues.push(radio.value?.toLowerCase().trim());
          });

          // Navigate to results
          navigateToResults();
          
          // Filter results based on selected values
          filterQuizResults(selectedRadioValues);
        } else if (targetStepNumber) {
          navigateToStep(targetStepNumber);
        }
      } else if (targetStepNumber) {
        // Handle other navigation links (fallback)
        navigateToStep(targetStepNumber);
      }
    }, true); // Use capture phase to run before other handlers
  });
  
  // Also handle back buttons that might not have #quiz-step href
  // This covers cases where back buttons might have different hrefs or no href
  document.querySelectorAll('a.btn--secondary').forEach(link => {
    // Skip if already handled above or if it's not in a quiz step
    if (link.hasAttribute('data-quiz-validation')) return;
    if (!link.closest('.quiz-step') && !link.closest('section.quiz-step')) return;
    
    link.setAttribute('data-quiz-back-button', 'true');
    
    link.addEventListener('click', (evt) => {
      // Only handle if it's not a #quiz-step link (those are handled above)
      let href = link.getAttribute('href');
      if (href && href.startsWith('#quiz-step')) return;
      
      evt.preventDefault();
      evt.stopPropagation();
      
      // Calculate previous step from current step
      let currentStep = getCurrentStepNumber();
      if (currentStep && currentStep > 1) {
        let previousStep = currentStep - 1;
        navigateToStep(previousStep);
      }
    }, true);
  });
  
  // Handle links with #see-my-results href (may not have #quiz-step prefix)
  document.querySelectorAll('a[href*="#see-my-results"]').forEach(link => {
    // Skip if already has validation listener
    if (link.hasAttribute('data-quiz-see-results')) return;
    link.setAttribute('data-quiz-see-results', 'true');
    
    link.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      
      let target = evt.target.getAttribute('href') ? evt.target : evt.target.closest('a');
      if (!target) return;
      
      // Only validate if it's a primary or callout button
      if (target.classList.contains('btn--primary') || target.classList.contains('btn--callout')) {
        let questionContainer = target.closest('section');
        if (!questionContainer) {
          questionContainer = target.closest('.section-blocks') || target.closest('.shopify-section');
        }
        
        // Check if we have required fields that need validation
        if (questionContainer && questionContainer.querySelectorAll('input[required]').length) {
          let requiredInput = questionContainer.querySelector('input[required]');
          // Check if it's a radio button and if any is checked
          if (requiredInput.type === 'radio') {
            let checkedRadio = questionContainer.querySelector('input[required]:checked');
            if (!checkedRadio) {
              // No radio button is checked, validate
              let isValid = validate(requiredInput, questionContainer);
              if (!isValid) {
                evt.preventDefault();
                evt.stopPropagation();
                return false;
              }
            } else {
              // Radio is checked, remove any error messages
              questionContainer.querySelectorAll('input[required]').forEach((e) => {
                e.classList.remove('error');
              });
              let errorMsg = questionContainer.querySelector('.error-message');
              if (errorMsg) errorMsg.remove();
            }
          } else {
            // Other input types (text, email, etc.)
            let isValid = validate(requiredInput, questionContainer);
            if (!isValid) {
              evt.preventDefault();
              evt.stopPropagation();
              return false;
            }
          }
        }
      }
      
      // Collect all selected radio button values from all quiz steps
      let selectedRadioValues = [];
      document.querySelectorAll('.quiz-step input[type="radio"]:checked').forEach((radio) => {
        selectedRadioValues.push(radio.value?.toLowerCase().trim());
      });
      
      // Navigate to results
      navigateToResults();
      
      // Filter results based on selected values
      filterQuizResults(selectedRadioValues);
    }, true);
  });
}

// Function to filter quiz results based on selected values
function filterQuizResults(selectedRadioValues) {
  if (!selectedRadioValues || selectedRadioValues.length === 0) return;
 
  // Find elements with matching quizMapText using hierarchical matching
  let elementsWithMatches = [];
  let maxMatchCount = 0;
  let exactMatches = []; // Store exact matches (all criteria match)

  // Helper function to normalize price strings (handles $40-$75 vs $40-75)
  function normalizePriceValue(str) {
    if (!str) return '';
    // Remove all spaces and convert to lowercase
    let normalized = str.replace(/\s+/g, '').toLowerCase();
    // Normalize price ranges: $40-$75 becomes $40-75 (remove $ before second number)
    // Only apply to values that look like price ranges
    if (normalized.includes('$') && normalized.includes('-')) {
      // Match pattern like $40-$75 or $40-75 and normalize to $40-75
      normalized = normalized.replace(/\$(\d+)-?\$?(\d+)/g, '$1-$2');
      // Add $ back at the start
      normalized = '$' + normalized;
    }
    return normalized;
  }

  let trimmedSelectedRadioValues = selectedRadioValues
  .map(v => normalizePriceValue(v));

  // Check each element to see if it contains ALL selected values
  document.querySelectorAll("[data-quiz-map-text]").forEach((element) => {
    let quizMapText = element.getAttribute('data-quiz-map-text');
    if (!quizMapText) {
      element.classList.add('hidden');
      return;
    }

    // Normalize quizMapText using the same normalization function
    let normalizedQuizMapText = quizMapText.replace(/\s+/g, '').toLowerCase();
    
    // Split by comma and handle "/" separator (e.g., "$75+ / no budget")
    let quizMapValues = normalizedQuizMapText.split(',').map(v => v.trim());
    
    // Expand values that contain "/" separator and normalize each value
    let expandedQuizMapValues = [];
    quizMapValues.forEach(val => {
      if (val.includes('/')) {
        val.split('/').forEach(part => {
          expandedQuizMapValues.push(normalizePriceValue(part.trim()));
        });
      } else {
        expandedQuizMapValues.push(normalizePriceValue(val));
      }
    });

    // Check if ALL selected values are present in this element's quizMapText
    // This works even if data-quiz-map-text has more values than selected
    let allValuesMatch = trimmedSelectedRadioValues.every(selectedValue => {
      // Check if selected value exactly matches any value in the expanded quizMapValues array
      // This ensures we match complete values, not substrings
      return expandedQuizMapValues.some(mapValue => {
        // Exact match (case-insensitive since we normalized)
        return mapValue === selectedValue;
      });
    });

    if (allValuesMatch) {
      element.classList.remove('hidden');
      exactMatches.push(element);
    } else {
      element.classList.add('hidden');
    }
  });
  
  if (exactMatches.length > 0) {
    // Show only exact matches
    document.querySelectorAll("[data-quiz-map-text]").forEach((element) => {
      if (exactMatches.includes(element)) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  } else if (elementsWithMatches.length > 0) {
    // No exact matches - use fallback strategy
    // Sort by: budget match priority, then match count, then match ratio
    elementsWithMatches.sort((a, b) => {
      // First priority: budget matches
      if (a.budgetMatches && !b.budgetMatches) return -1;
      if (!a.budgetMatches && b.budgetMatches) return 1;
      
      // Second priority: match count
      if (a.matchCount !== b.matchCount) {
        return b.matchCount - a.matchCount;
      }
      
      // Third priority: match ratio
      return b.matchRatio - a.matchRatio;
    });
    
    // Get the best match count (after sorting)
    let bestMatchCount = elementsWithMatches[0].matchCount;
    let bestBudgetMatch = elementsWithMatches[0].budgetMatches;
    
    // Show elements with best matches
    // If best match has budget match, prioritize those; otherwise show all with best match count
    document.querySelectorAll("[data-quiz-map-text]").forEach((element) => {
      let matchingItem = elementsWithMatches.find(item => item.element === element);
      
      if (matchingItem) {
        let shouldShow = false;
        
        if (bestBudgetMatch) {
          // If best matches include budget matches, show only budget matches with best count
          shouldShow = matchingItem.budgetMatches && 
                      matchingItem.matchCount === bestMatchCount;
        } else {
          // No budget matches in best results, show all with best match count
          shouldShow = matchingItem.matchCount === bestMatchCount;
        }
        
        if (shouldShow) {
          element.classList.remove('hidden');
        } else {
          element.classList.add('hidden');
        }
      } else {
        element.classList.add('hidden');
      }
    });
  } else {
    // No matches at all - hide all elements
    document.querySelectorAll("[data-quiz-map-text]").forEach((element) => {
      element.classList.add('hidden');
    });
  }
}

// Function to handle request-my-result button click
function addRequestMyResultHandler() {
  document.querySelectorAll('a[href="#request-my-result"]').forEach(link => {
    // Skip if already has handler
    if (link.hasAttribute('data-request-result-handler')) return;
    link.setAttribute('data-request-result-handler', 'true');
    
    link.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      
      // Hide hero section
      let heroSection = link.closest('section') || 
                        link.closest('.hero-image-text') ||
                        link.closest('.image-hero') ||
                        document.querySelector('.hero-image-text') ||
                        document.querySelector('.image-hero');
      
      if (heroSection) {
        heroSection.style.display = 'none';
      }
      
      // Also hide intro screen sections in main
      document.querySelectorAll('.main .shopify-section').forEach((section, index) => {
        // Hide intro/hero sections (typically the first few sections in main)
        if (index < 2) {
          section.style.display = 'none';
        }
      });
      
      // Get quiz data from cookie
      let quizData = getCookie('quiz_data');
      let selectedRadioValues = [];
      
      if (quizData && Array.isArray(quizData)) {
        selectedRadioValues = quizData;
      } else {
        // Fallback: try to get from DOM if cookie doesn't exist
        document.querySelectorAll('.quiz-step input[type="radio"]:checked').forEach((radio) => {
          selectedRadioValues.push(radio.value?.toLowerCase().trim());
        });
      }
      
      // Navigate to results page
      navigateToResults();
      
      // Filter results based on quiz data
      filterQuizResults(selectedRadioValues);
    }, true);
  });
}

// Add validation for quiz step navigation links (next buttons)
// Handle both cases: DOM already loaded or still loading
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addQuizStepValidation);
  document.addEventListener('DOMContentLoaded', addRequestMyResultHandler);
} else {
  // DOM already loaded
  addQuizStepValidation();
  addRequestMyResultHandler();
}

// Also run on window load as backup (in case sections load dynamically)
window.addEventListener('load', () => {
  setTimeout(addQuizStepValidation, 100);
  setTimeout(addRequestMyResultHandler, 100);
});

// Add event listeners for radio button changes (works for all steps including dynamically shown ones)
// Use event delegation to handle inputs in dynamically shown sections
let radioChangeHandlerAdded = false;

function addRadioButtonListeners() {
  // Only add listener once using event delegation
  if (radioChangeHandlerAdded) return;
  radioChangeHandlerAdded = true;
  
  // Add event listener using event delegation on document level
  // This will work for all radio buttons, including those in dynamically shown sections
  document.addEventListener('change', handleRadioChange);
}

function handleRadioChange(evt) {
  // Only handle radio button changes
  if (evt.target.type !== 'radio') return;
  
  let target = evt.target;
  let questionContainer = target.closest('section');
  
  // Try to find the question container if not found in section
  if (!questionContainer || !questionContainer.classList.contains('quiz-step')) {
    questionContainer = target.closest('.section-blocks') || target.closest('.shopify-section') || target.closest('.quiz-step');
  }
  
  if (!questionContainer) return;
  
  // Check if we have required fields
  if (questionContainer.querySelectorAll('input[required]').length) {
    // Remove any existing error message when a selection is made
    questionContainer.querySelectorAll('input[required]').forEach((e) => {
      e.classList.remove('error');
    });
    let errorMsg = questionContainer.querySelector('.error-message');
    if (errorMsg) errorMsg.remove();
  }
  
  // Update selected state - remove selected class from all radio options in the same group
  // Radio buttons with the same name attribute are in the same group
  let radioName = target.getAttribute('name');
  
  if (radioName) {
    // Find all radios with the same name (search document-wide since name should be unique per question)
    // This ensures we find all radios in the group even if they're in different containers
    document.querySelectorAll(`input[type="radio"][name="${radioName}"]`).forEach((ir) => {
      // Find the radio-block parent (works for both radio-block and radio-block-v3)
      let parent = ir.closest('.radio-block') || ir.closest('.radio-block-v3') || ir.closest('label') || ir.parentElement;
      if (parent) {
        parent.classList.remove('selected');
      }
    });
  } else {
    // Fallback: find the immediate container that holds all radios for this question
    // Try to find the container that holds all radio options (like .section-blocks or .rich-text__inner)
    let radioGroupContainer = target.closest('.section-blocks') || 
                              target.closest('.rich-text__inner') || 
                              target.closest('.rich-text') ||
                              target.parentElement?.parentElement ||
                              questionContainer;
    
    if (radioGroupContainer) {
      radioGroupContainer.querySelectorAll('input[type="radio"]').forEach((ir) => {
        let parent = ir.closest('.radio-block') || ir.closest('.radio-block-v3') || ir.closest('label') || ir.parentElement;
        if (parent) {
          parent.classList.remove('selected');
        }
      });
    }
  }
  
  // Add selected class to the checked radio's parent
  if (target.checked) {
    // Find the radio-block parent (works for both radio-block and radio-block-v3)
    let parent = target.closest('.radio-block') || target.closest('.radio-block-v3') || target.closest('label') || target.parentElement;
    if (parent) {
      parent.classList.add('selected');
    }
  }
  
  // Handle textarea visibility for "specify" options
  let textarea = document.getElementById(target.getAttribute('id') + '-textarea');
  if (textarea) {
    if (target.value.toLowerCase().indexOf('specify') !== -1) {
      textarea.classList.remove('hidden');
    } else {
      textarea.classList.add('hidden');
    }
  }
}

// Initialize radio button listeners
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addRadioButtonListeners);
} else {
  addRadioButtonListeners();
}

// Also run on window load as backup
window.addEventListener('load', () => {
  setTimeout(addRadioButtonListeners, 100);
  setTimeout(initializeProgressBar, 100);
  setTimeout(toggleRequestMyResultButton, 100);
});

// Function to handle #see-my-results on page load
function handleSeeMyResultsOnLoad() {
  // Check if URL hash contains #see-my-results
  if (window.location.hash === '#see-my-results' || window.location.hash.includes('#see-my-results')) {
    // Get quiz data from cookie
    let quizData = getCookie('quiz_data');

    if (quizData && Array.isArray(quizData)) {
      
        // Hide hero section
        let heroSection = document.querySelector('.hero-image-text') ||
                          document.querySelector('.image-hero');
        
        if (heroSection) {
          heroSection.style.display = 'none';
        }
        
        // Also hide intro screen sections in main
        document.querySelectorAll('.main .shopify-section').forEach((section, index) => {
          // Hide intro/hero sections (typically the first few sections in main)
          if (index < 2) {
            section.style.display = 'none';
          }
        });
        
        // Navigate to results page
        navigateToResults();
        
        // Filter results based on quiz data
        if (quizData.length > 0) {
          // Use setTimeout to ensure DOM is ready
          setTimeout(() => {
            filterQuizResults(quizData);
          }, 100);
        }
    }
    
  }
}

hideAllSections();

// Initialize progress bar on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProgressBar);
  document.addEventListener('DOMContentLoaded', toggleRequestMyResultButton);
  document.addEventListener('DOMContentLoaded', handleSeeMyResultsOnLoad);
} else {
  initializeProgressBar();
  toggleRequestMyResultButton();
  handleSeeMyResultsOnLoad();
}

// Also run on window load as backup
window.addEventListener('load', () => {
  setTimeout(handleSeeMyResultsOnLoad, 200);
});

// Handle hash changes (e.g., when navigating with browser back/forward)
window.addEventListener('hashchange', () => {
  handleSeeMyResultsOnLoad();
});

